<template>
  <div>
    <div>
      <h1>Buscar</h1>
    </div>
    <form @submit.prevent="search">
      <v-text-field
        ref="searchField"
        @focus="$event.target.select()"
        prepend-inner-icon="mdi-magnify"
        outlined
        v-model="searchText"
        @keyup.enter="search"
        type="search"
        enterkeyhint="search"
        hide-details
        clearable
      ></v-text-field>
    </form>

    <v-tabs v-model="tab" v-if="data && (data.movie.results.length || data.tv.results.length)">
      <v-tab>Pelis</v-tab>
      <v-tab>Series</v-tab>
    </v-tabs>

    <div style="margin-top: 8px">
      <div>
        <div v-if="data[type].results">
          <div v-for="item in data[type].results" :key="item.id" @click="onClick(item)" style="cursor: pointer">
            <MovieListItem :item="item" />
          </div>
          <div v-if="data[type].total_results > data[type].results.length">
            Nota: se muestran solo los primeros {{ data[type].results.length }} resultados de
            {{ data[type].total_results }}
          </div>
        </div>
        <div v-else>
          <div v-if="loading">Loading...</div>
          <div v-else-if="searchText">No se han encontrado resultados</div>
          <div v-else></div>
        </div>
      </div>
    </div>

    <!-- details in bottom sheet -->
    <v-bottom-sheet :value="selectedId" scrollable fullscreen>
      <v-card>
        <v-card-title>
          <v-btn icon @click="selectedId = ''">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <MovieDetailPage :tmdb_id="selectedId" />
        </v-card-text>
      </v-card>
    </v-bottom-sheet>
  </div>
</template>

<script>
import api from '@/assets/api'
import MovieListItem from './MovieListItem.vue'
import MovieDetailPage from './v2/MovieDetailPage.vue'

export default {
  components: {
    MovieListItem,
    MovieDetailPage,
  },
  data() {
    return {
      selectedId: '',
      searchText: '',

      loading: false,
      //search data
      tab: 0,
      data: { movie: { results: [] }, tv: { results: [] } },
    }
  },
  computed: {
    type() {
      return ['movie', 'tv'][this.tab]
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.searchField.focus()
    })
  },
  methods: {
    async onClick(item) {
      const tmdb_id = this.type + '/' + item.id
      this.$emit('click', tmdb_id)
      this.selectedId = tmdb_id
      //await this.add(tmdb_id)
      //this.$emit('done')
    },
    async search() {
      this.loading = true
      const path = `/watchlistt/search?query=${this.searchText}`
      const x = await api.apiFetch(path)
      if (x.ok) {
        const data = await x.json()
        this.data = { ...data }
      }
      this.loading = false
    },
    async cancel() {
      this.$emit('cancel')
    },
    /**
     *
     * @deprecated
     */
    async add(tmdb_id) {
      this.loading = true
      const x = await api.apiFetch('/watchlistt/get-movie', {
        method: 'POST',
        body: JSON.stringify({ tmdb_id }),
      })
      if (x.ok) {
        this.$emit('done')
      } else {
        alert('Algo ha fallado sorry.')
        this.$emit('done')
      }
      this.loading = false
    },
  },
}
</script>

<style lang="scss" scoped></style>
